// Module
var code = `<div class="tfa container text-center gap-4">
    <div>
        <div class="logo">
            <svg id="logo" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 199.8 43.1" xml:space="preserve">
                <style type="text/css">
                    .st0{fill:#388EE9;}
                    .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#388EE9;}
                </style>
                <g>
                    <path class="st0" d="M12.3,11l-4.5-0.6l0.1,0.5c0.1,1,1,1.8,2,1.9H10C11.1,12.9,12.2,12.1,12.3,11z"/>
                    <path class="st0" d="M28,24.9c4.8-1.4,8.2-5.8,8.2-10.8c0-6.2-5-11.3-11.3-11.3H4.4v4.3c4.1-1.3,9.1,0.5,11.3,3.2
                                c0,0,10.5-0.9,11.9,5.9c0,0-9.9-4.2-15.4,3.6c-1.3,1.9-1.7,4.1-2.4,6.8c-1.5,5.1-2.3,8.9-4.4,12.9h7.2l2.6-11.9h4l7,11.9h9.1
                                L27,25.4l0.9-0.5H28z"/>
                    <path class="st1" d="M145.1,39.5V9.4h9.9c2.9,0,5.5,0.6,7.7,1.7c2.3,1.2,4,2.8,5.2,5.1c1.2,2.2,1.8,4.9,1.8,8c0,3.2-0.6,6-1.9,8.4
                                c-1.2,2.3-3.1,4.1-5.5,5.2c-2.3,1.2-5.1,1.7-8.3,1.7H145.1z M160.8,31.3c1.5-1.4,2.3-3.6,2.3-6.9c0-2.2-0.3-3.9-1-5.1l0,0l0,0
                                c-0.6-1.2-1.5-2.1-2.7-2.7l0,0l0,0c-1.2-0.6-2.8-1-4.8-1h-2.8v17.9h2.1C157.1,33.5,159.4,32.6,160.8,31.3z M191.9,23.6
                                c1,0.6,1.9,1.5,2.5,2.5c0.7,1.2,1,2.6,1,4.3c0,1.9-0.4,3.6-1.4,5l0,0l0,0c-1,1.5-2.3,2.5-3.9,3.2l0,0l0,0c-1.7,0.7-3.5,1-5.6,1
                                h-11.1V9.4h9.3c2.3,0,4.4,0.2,6,0.7c1.7,0.5,3.2,1.3,4.3,2.7c1,1.3,1.5,3,1.5,4.9c0,1.2-0.2,2.4-0.8,3.5
                                C193.4,22.1,192.7,23,191.9,23.6z M180,33.5h3.8c2.3,0,3.4-0.5,3.9-0.9c0.6-0.6,0.9-1.4,0.9-2.6c0-0.7-0.1-1.2-0.4-1.7l0,0l0,0
                                c-0.1-0.3-0.6-0.6-1.2-0.9l0,0l0,0c-0.7-0.3-1.7-0.5-3.3-0.5H180V33.5z M187.1,20.2c0.4-0.3,0.8-1,0.8-2.1c0-1-0.3-1.5-0.8-1.8l0,0
                                l0,0c-0.6-0.4-1.9-0.8-4.1-0.8H180v5.4h3.4C185.6,20.9,186.7,20.5,187.1,20.2z M53.5,36.5L53.5,36.5l0.1,3h6.9V27.2
                                c0-2.1-0.1-3.8-0.5-5.4c-0.3-1.6-1-2.9-1.8-3.9s-2-1.9-3.4-2.4c-1.4-0.6-3.2-0.8-5.4-0.8c-2,0-3.9,0.3-5.8,1
                                c-1.9,0.6-3.5,1.6-4.9,2.9l4,4.1c0.8-0.9,1.7-1.6,2.7-2.1c1-0.6,2.1-0.8,3.4-0.8c1.3,0,2.4,0.4,3.4,1.2c1,0.8,1.5,1.8,1.5,3.2
                                c-1,0-2.1,0-3.4,0.1c-1.2,0-2.4,0.1-3.7,0.3c-1.2,0.1-2.3,0.4-3.5,0.8c-1.1,0.3-2.1,0.8-3,1.5c-0.9,0.6-1.6,1.5-2.1,2.4
                                s-0.8,2.1-0.8,3.6c0,1.2,0.2,2.3,0.7,3.2c0.5,1,1.1,1.7,1.9,2.3s1.7,1.1,2.8,1.4c1,0.3,2.1,0.5,3.3,0.5c1.5,0,3-0.3,4.4-0.8
                                C51.5,38.7,52.7,37.8,53.5,36.5z M51.7,28.8c-0.6,0-1.3,0-2.1,0.1c-0.8,0-1.7,0.1-2.5,0.4c-0.8,0.2-1.5,0.6-2,1s-0.8,1.1-0.8,1.9
                                c0,0.9,0.4,1.6,1.2,2c0.8,0.4,1.6,0.6,2.4,0.6c0.8,0,1.5-0.1,2.1-0.3c0.7-0.2,1.3-0.5,1.9-0.8c0.6-0.3,1-0.8,1.2-1.4
                                c0.3-0.6,0.5-1.2,0.5-2v-1.6H51.7z M108.3,38.9c1.9-0.8,3.4-2,4.6-3.6l-5.2-3.9c-0.6,0.9-1.4,1.6-2.3,2.1c-0.8,0.6-1.9,0.8-3.1,0.8
                                c-1.5,0-2.7-0.4-3.7-1.2c-1-0.9-1.7-2-1.9-3.5h17.4v-2.3c0-1.9-0.3-3.7-0.8-5.2c-0.6-1.6-1.3-2.9-2.3-4c-1-1.1-2.1-2-3.6-2.6
                                c-1.4-0.6-3-0.9-4.7-0.9c-1.9,0-3.7,0.3-5.3,0.9c-1.7,0.6-3,1.5-4.3,2.6c-1.2,1.1-2.1,2.4-2.8,4c-0.7,1.6-1,3.3-1,5.2
                                s0.3,3.7,1,5.2c0.7,1.6,1.7,2.9,2.8,4.1c1.2,1.1,2.7,1.9,4.3,2.6c1.7,0.6,3.5,0.9,5.3,0.9C104.5,40.2,106.4,39.8,108.3,38.9z
                                 M105.1,21.3c0.9,0.9,1.3,2,1.2,3.2h-9.9c0-0.6,0.1-1.2,0.4-1.7c0.3-0.6,0.6-1,1-1.5c0.5-0.4,1-0.8,1.7-1s1.4-0.4,2.2-0.4
                                C103.2,20,104.3,20.4,105.1,21.3z M117.7,15.2h7.2v3.3h0.1c0.2-0.5,0.6-1,1-1.4c0.4-0.5,1-0.9,1.5-1.2c0.6-0.3,1.3-0.7,2.1-0.9
                                s1.6-0.3,2.5-0.3c1.9,0,3.5,0.3,4.6,0.9c1.2,0.6,2.1,1.4,2.7,2.4c0.7,1,1.1,2.3,1.4,3.7c0.2,1.4,0.3,2.9,0.3,4.6v13.4h-7.5V27.6
                                c0-0.7,0-1.5-0.1-2.1c0-0.8-0.2-1.5-0.5-2.1c-0.2-0.6-0.6-1.2-1.2-1.5c-0.5-0.4-1.2-0.6-2.2-0.6c-1,0-1.7,0.2-2.3,0.6
                                c-0.6,0.3-1,0.8-1.4,1.4c-0.3,0.6-0.5,1.2-0.6,1.9c-0.1,0.8-0.1,1.5-0.1,2.3v12.2h-7.5V15.2H117.7z M61,15.2h8.1l6.1,16.5h0.1
                                L81,15.2h7.5L79,39.5H71L61,15.2z"/>
                </g>
            </svg>
        </div>
        <h3 class="m-0">Two-Factor Authentication</h3>
    </div>
    <div class="faded-icon-lock">
        <i class="icon-unlock"></i>
    </div>
    <div>
        <p class="m-0">Certificate name: <strong data-bind="text: certificateName"></strong></p>
        <p class="m-0">Enter the 6-digit authentication code generated by your app</p>
    </div>
    <form data-bind="submit: verify" class="tfa-form">
        <div class="d-flex justify-content-center">
            <div class="tfa-input-wrap field-real">
                <input type="text" class="tfa-token-input w-input" maxlength="6" placeholder="000000" minlength="6" autocomplete="off" data-bind="textInput: code, hasFocus: codeHasFocus">
                <div class="tfa-input field-fake"></div>
                <div class="tfa-input field-fake"></div>
                <div class="tfa-input field-fake"></div>
                <div class="tfa-input field-fake"></div>
                <div class="tfa-input field-fake"></div>
                <div class="tfa-input field-fake"></div>
            </div>
        </div>

        <div class="panel panel-default text-left additional-settings-panel">
            <div role="tab" id="sessionSettings" data-toggle="collapse" href="#sessionSettingsCollapse" aria-expanded="false" aria-controls="sessionSettingsCollapse" class="collapsed">
                <h5 class="panel-title">
                    <a class="collapsed text-lighter d-flex justify-content-between">
                        Additional session settings
                        <i class="icon-arrow-down"></i>
                    </a>
                </h5>
            </div>
            <div id="sessionSettingsCollapse" class="panel-collapse collapse" role="tabpanel" aria-labelledby="sessionSettingsCollapse">
                <div class="panel-body pt-0 d-flex flex-vertical">
                    <div class="margin-bottom">
                        <label for="maxSessionDuration">Session duration</label>
                        <div class="input-group">
                            <input id="maxSessionDuration" type="number" class="form-control" data-bind="value: sessionDurationInMin, attr: { max: maxSessionDurationInMin() }">
                            <div class="input-group-addon">minutes</div>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex flex-wrap justify-content-between">
                            <label>Access clearance</label>
                        </div>
                        <div class="d-flex flex-wrap gap-2">
                            <div class="radio radio-default radio-inline">
                                <input id="browserTrust" type="radio" data-bind="checked: limitType" value="browser">
                                <label for="browserTrust" class="margin-left-xs mb-0"><small>Trust only this browser</small></label>
                            </div>
                            <div class="radio radio-default radio-inline">
                                <input id="allTrust" type="radio" data-bind="checked: limitType" value="noLimit">
                                <label for="allTrust" class="margin-left-xs mb-0"><small>Trust all clients</small></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button class="btn btn-primary rounded-pill" data-bind="hasFocus: proceedHasFocus"><i class="icon-arrow-thin-right"></i> Proceed</button>
    </form>
</div>
`;
// Exports
export default code;